{
  "fr": {
    "dashboard": {
      "greetings": {
        "afternoon": "Bon après-midi {first_name}",
        "evening": "Bonsoir {first_name}",
        "morning": "Bonjour {first_name}",
        "night": "Bonne nuit {first_name}"
      },
      "milestones": {
        "action_title_decision": "Choisissez {name}",
        "action_title_survey": "Répondez à {name}",
        "action_title_ticket": "Nouveau message à propos de {name}",
        "count_open": "{count} en attente",
        "journey_hide": "Masquer le parcours du projet",
        "journey_show": "Voir le parcours du projet",
        "journey_step_active": "En cours",
        "journey_step_completed": "Terminée",
        "journey_step_planned": "Planifiée",
        "other_empty_subtitle": "{client} vous préviendra dès qu'il y aura quelque chose pour vous.",
        "other_empty_title": "Vous êtes à jour",
        "other_promoted_title": "Demande votre attention",
        "other_title": "Autres actions",
        "stage_done_subtitle": "{client} vous préviendra dès que la prochaine étape arrive.",
        "stage_done_title": "Tout est fait pour cette phase",
        "stage_empty": "Rien à faire dans cette phase pour l'instant.",
        "stage_eyebrow": "Phase actuelle",
        "stage_final_subtitle": "Toutes les étapes de votre projet sont terminées. Nous vous tenons au courant si quelque chose change.",
        "stage_final_title": "Vous avez tout terminé",
        "stage_last": "Ceci est la dernière phase",
        "stage_next": "Ensuite : {phase}",
        "stage_position": "Phase {current} sur {total}",
        "stage_todo_title": "Pour terminer cette phase"
      },
      "titles": {
        "activityFeed": "Activités",
        "assignedTasks": "Mes Tâches",
        "newsFeed": "Fil d'Actualité",
        "ongoingTickets": "En Cours",
        "openTickets": "Ouvert",
        "progress": "Progression",
        "tickets": "Conversations",
        "totalTickets": "Toutes les conversations",
        "unreadTickets": "Non Lu",
        "yourAssignedTickets": "Assignées à vous"
      }
    }
  }
}
